// utils/romanUtils.js

// Convert number to Roman numeral
export const ConvertoRoman = (num) => {
  if (!num || isNaN(num)) return num;
  const romans = [
    ["M", 1000],
    ["CM", 900],
    ["D", 500],
    ["CD", 400],
    ["C", 100],
    ["XC", 90],
    ["L", 50],
    ["XL", 40],
    ["X", 10],
    ["IX", 9],
    ["V", 5],
    ["IV", 4],
    ["I", 1],
  ];
  let result = "";
  for (const [symbol, value] of romans) {
    while (num >= value) {
      result += symbol;
      num -= value;
    }
  }
  return result;
};

// Convert any "Semester X" or "Sem X" to Roman version
export const convertSemesterToRoman = (text = "") => {
  if (!text) return text;

  return text.replace(/(Semester|Sem)[^\d]*(\d+)/gi, (_, prefix, num) => {
    return `${prefix} ${ConvertoRoman(Number(num))}`;
  });
};

// Convert an array of course labels to Roman form
// utils/romanUtils.js

export const formatCourseListWithRoman = (courseArray = []) => {
  if (!Array.isArray(courseArray)) return "-";

  // Convert each course name to Roman form
  const formattedCourses = courseArray
    .filter(Boolean)
    .map((course) => convertSemesterToRoman(course.trim()));

  // Join with space + comma + space
  return formattedCourses.join(" , ");
};


export const formatCourseListWithRomanString = (courseInput) => {
  if (!courseInput) return "-";

  // If a single string → wrap into array
  const courseArray = Array.isArray(courseInput) ? courseInput : [courseInput];

  const formattedCourses = courseArray
    .filter(Boolean)
    .map((course) => convertSemesterToRoman(course.trim()));

  return formattedCourses.join(" , ");
};


 